"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
const Token_1 = __importDefault(require("./Token"));
const WinOutline_1 = __importDefault(require("./WinOutline"));
const GRID_PADDING = 5;
const useStyles = (0, react_jss_1.createUseStyles)({
    gridWrapper: {
        borderRadius: GRID_PADDING,
        boxShadow: "0px 2px 2px #0006",
    },
    grid: {
        width: 350,
        display: "flex",
        margin: `0 ${GRID_PADDING}px`,
        position: "relative",
        zIndex: 0,
        "&:before, &:after": {
            width: GRID_PADDING,
            backgroundColor: "var(--tiffany)",
            content: '" "',
            display: "block",
            top: 0,
            bottom: 0,
            position: "absolute",
        },
        "&:before": {
            left: -GRID_PADDING,
            borderRadius: `${GRID_PADDING}px 0 0 ${GRID_PADDING}px`,
        },
        "&:after": {
            right: -GRID_PADDING,
            borderRadius: `0 ${GRID_PADDING}px ${GRID_PADDING}px 0`,
        },
    },
    column: {
        flex: 1,
        display: "flex",
        flexDirection: "column-reverse",
        cursor: "pointer",
        position: "relative",
        borderTop: `var(--tiffany) ${GRID_PADDING}px solid`,
        borderBottom: `var(--tiffany) ${GRID_PADDING}px solid`,
        "&:hover, &:focus": {
            borderTop: `var(--tiffany-hover) ${GRID_PADDING}px solid`,
            borderBottom: `var(--tiffany-hover) ${GRID_PADDING}px solid`,
        },
        "&:hover $cell, &:focus $cell": {
            background: "-webkit-radial-gradient(50% 50%, circle, transparent 57%, var(--tiffany-hover) 57%)",
        },
    },
    cell: {
        // Make cell as wide as column
        width: "100%",
        // Use padding bottom hack to make cell as heigh as it is wide
        height: 0,
        paddingBottom: "100%",
        background: "-webkit-radial-gradient(50% 50%, circle, transparent 57%, var(--tiffany) 57%)",
        position: "relative",
    },
});
const GameBoard = ({ grid, winSequences, onClick, }) => {
    const classes = useStyles();
    return (react_1.default.createElement("div", { className: classes.gridWrapper },
        react_1.default.createElement("div", { className: classes.grid }, grid.map((column, x) => (react_1.default.createElement("div", { className: classes.column, key: x, onClick: onClick(x) },
            column.map((player, y) => (react_1.default.createElement("div", { className: classes.cell, key: y }, player === null ? null : react_1.default.createElement(Token_1.default, { player: player, y: y })))),
            x === 0
                ? winSequences.map(({ origin, length, rotation }) => (react_1.default.createElement(WinOutline_1.default, { length: length, rotation: rotation, origin: origin, key: `${origin.x}-${origin.y}-${rotation}` })))
                : null))))));
};
exports.default = GameBoard;
